import React from 'react';
import { Button } from './ui/button';

const LPHeader = ({ onOpenModal }) => (
  <header className="backdrop-blur-xl bg-[#F9F8F6]/80 border-b border-[#D5D1C8]/50 sticky top-0 z-50">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-4">
      <div className="flex items-center justify-between">
        <span className="font-display text-lg font-bold text-[#111C16]">Trademark Application Hub</span>
        <Button onClick={() => onOpenModal && onOpenModal('Register My Trademark - Header')} className="bg-[#C85A40] hover:bg-[#A64730] text-white btn-hover">
          Register My Trademark
        </Button>
      </div>
    </div>
  </header>
);

export default LPHeader;
